import { render, staticRenderFns } from "./LiftTypeSelect.vue?vue&type=template&id=74f013f8&scoped=true&lang=pug"
import script from "./LiftTypeSelect.vue?vue&type=script&lang=js"
export * from "./LiftTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f013f8",
  null
  
)

export default component.exports